import { useEffect, useState } from "react";
import { CloudSun } from "lucide-react";
import { Reveal } from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

const BAD_CODES = [51, 53, 55, 61, 63, 65, 66, 67, 71, 73, 75, 77, 80, 81, 82, 85, 86, 95, 96, 99];

const streichwetter = (w) =>
  BAD_CODES.includes(w.code) || w.temp < 5
    ? "Heute lieber innen gestalten – wir kennen da was."
    : "Gute Bedingungen für Fassade & Außenanstrich.";

export const RegionLive = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/regional`)
      .then((r) => r.json())
      .then(setData)
      .catch(() => {});
  }, []);

  const w = data?.weather;

  return (
    <section id="region" className="bg-white border-y border-line" data-testid="region-live-section">
      <div className="container-x py-16 md:py-24">
        <div className="flex flex-col lg:flex-row lg:items-start gap-10 lg:gap-16">
          <Reveal className="lg:w-80 shrink-0">
            <p className="kicker">Live aus der Region</p>
            <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight mt-3 text-ink" data-testid="region-live-title">
              Olpe <span className="font-fraktur text-golddark">heute.</span>
            </h2>
            {w ? (
              <>
                <p className="mt-5 text-sm text-muted leading-relaxed flex items-center gap-3">
                  <CloudSun size={26} className="text-golddark" strokeWidth={1.5} />
                  <span className="font-mono text-3xl font-bold tracking-tight text-ink" data-testid="weather-temp">{w.temp}°</span>
                  <span data-testid="weather-condition">{w.label}</span>
                </p>
                <p className="font-mono text-xs text-muted mt-2">Wind {w.wind} km/h · Luftfeuchte {w.humidity}%</p>
                <p className="font-display font-medium text-lg text-ink/80 mt-4" data-testid="weather-vibe">
                  „{streichwetter(w)}“
                </p>
              </>
            ) : (
              <div className="animate-pulse mt-5 h-10 w-48 bg-surface" />
            )}
          </Reveal>
          <Reveal delay={0.1} className="flex-1 lg:border-l lg:border-line lg:pl-16">
            <p className="kicker mb-6">Veranstaltungen in der Region</p>
            {data ? (
              <ul data-testid="events-list" className="grid sm:grid-cols-2 gap-x-12">
                {data.events.map((e, i) => (
                  <li key={e.title} data-testid={`event-item-${i}`} className="border-t border-line py-4">
                    <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-golddark font-bold">{e.dates}</p>
                    <p className="font-display text-lg font-semibold tracking-tight mt-1 leading-snug text-ink">{e.title}</p>
                    <p className="text-sm text-muted mt-1">{e.place} · {e.tag}</p>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="animate-pulse grid sm:grid-cols-2 gap-x-12 gap-y-4">
                {[0, 1, 2, 3].map((i) => (
                  <div key={i} className="h-16 bg-surface" />
                ))}
              </div>
            )}
            <p className="font-mono text-[10px] text-muted mt-6">{data?.source ?? "Daten werden geladen …"}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
